import { useHistory } from 'react-router-dom';
import React, {useState, useEffect, useRef} from 'react' 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faPlay, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FormControl, Button } from '@material-ui/core';
// import MomentUtils from "@date-io/moment";
import moment from "moment";
import "moment/locale/pt-br"
import FormData from 'form-data'
import { useDispatch } from "react-redux"
// import { saveAs } from 'file-saver';
import {
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
} from '../../../store/actions/snackbarActions.js';
import { postImportParceirosTreinamento, getImportParceirosTreinamentoLog } from '../../../services/api-auto'
import Paginacao from '../../../components/Paginacao';
import modeloParticipanteCampanha from '../../../assets/docs/modeloParticipanteCampanha.xlsx'
import LogImportacao from './components/LogImportacao';
import styles from './styles.module.scss'
import { trackPromise } from 'react-promise-tracker';


const dataInit = {
    id: '',
    titulo: '',
    instrucoes: '',
    dataInicio: moment(),
    dataFim:  moment(),
    tipo: 0,
    tempo: 0,
    perfil: 0,
    categoria:0,
    status: 0,
    obrigatorio: 0,
    parceiroAcaoExcluidos: [],
    parceiroAcaoAdicionar: [],
    perguntaAcaoExcluidos: [],
    perguntaAcaoAdicionar: [],
    textoCapaD: 'Escolha a Capa Desktop para o Treinamento',
    textoCapaM: 'Escolha a Capa Mobile para o Treinamento',
    textoCapaT: 'Escolha o arquivo de Treinamento',
    textoCapaA: 'Escolha o arquivo do Material de Apoio'
}



export default function Resultados(){

    const ref = useRef(null)
    const [dados, setDados] = useState(null)

    const [logPage, setLogPage] = useState(1)
    const [logMaxPage, setLogMaxPage] = useState(3)
    const [logList, setLogList] = useState([])
    
    const [loading, setLoading] = useState(false);
    const [participantes, setParticipantes] = useState([]);
    const [data, setData] = useState(dataInit);
    const [openModalComplete, setOpenModalComplete] = React.useState(false);
    const [treinamentoId, setTreinamentoId] = useState([]);
    const history = useHistory()

    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));


    const parceiroImportacaoExcel = async () => {
        setLoading(true)
        let formdata = new FormData();
        formdata.append('dados', dados)
        formdata.append('IdTreinamento', new URLSearchParams(history.location.search).get("treinamento"))
        try{
            
            const participantesApi = await postImportParceirosTreinamento(formdata);
            const participantes = participantesApi.parceirosImportacaoExcelResponde

            setParticipantes(participantes);
            
            participantes.map((participante) => {
                 const obj = {
                     "regional": participante.regional,
                     "filial": participante.filial,
                     "nomeParceiro": participante.nomeParceiro,
                     "idParceiro": participante.idParceiro,
                     "aviso": participante.aviso,
                 }

                 if(!obj.aviso){
                    data.parceiroAcaoAdicionar.push(obj);
                 }     
            })

            setOpenModalComplete(true);
         
            if(Boolean(participantesApi.sucesso)){
                showMsgS("Planilha processada com sucesso")
                setLoading(false);
            } else if(Boolean(participantesApi.parciamente)){
                showMsgW("Planilha parcialmente importada")
                setLoading(false);
            }
        }catch(e){
            showMsgE("Planilha não processada")
            setOpenModalComplete(false);
        }finally{
            setLoading(false)
        }
    }

    const getLogList = async () => {
        try{
            const idTreinamento = new URLSearchParams(history.location.search).get("treinamento")
            const info = await getImportParceirosTreinamentoLog(logPage, idTreinamento)
            setLogList(info.data.data.data) 
            setLogMaxPage(info.data.data.maxPage + 1)
        }catch(e){
        }
    }

     useEffect(()=>{getLogList()},[logPage])

    const onFileChange = (event) => {
        let file;
        if (event.target.files && event.target.files[0]) {
            file = event.target.files[0];
            if(file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                setDados(file);
            }else{
                showMsgE('Favor escolher arquivos .xlsx')
            }
        }
    };

    const callFileInput = () => {
        ref.current.click()
    }

    const obterLista = async(Id) => {
        trackPromise(
        ).catch(error => {
            showMsgE('Erro ao baixar os arquivos');
        })
    }

    return(
        <div className={`${styles.wrapper}`}>
            <div className={styles.title}>
                Importação de parceiros
            </div>
            <div className={`${styles.actions}`}>
                <div className={`${styles.card}`}>
                    <div className={`${styles.cardTitle}`}>
                        Orientações
                    </div>
                    <div className={`${styles.modelo}`}>
                        <FormControl>
                            <Button href={modeloParticipanteCampanha} download>
                                <FontAwesomeIcon icon={faDownload} className={styles.icon}/>
                                Baixar modelo de planilha
                            </Button>
                        </FormControl>
                    </div>
                    <div className={`${styles.orientacoes}`}>
                        <ul>
                            <li>
                                Clique em "Baixar modelo de planilha" para fazer o download da planilha de importação;
                            </li>
                            <li>
                                A planilha deve estar no formato .xlsx;
                            </li>
                            <li>
                                O arquivo não deve conter células mescladas;
                            </li>
                            <li>
                                A primeira linha deve conter o cabeçalho das colunas;
                            </li>
                            <li>
                                Deve haver somente uma aba no arquivo;
                            </li>
                            <li>
                                Após a importação, veja o resultado de cada registro clicando nos números processados;
                            </li>
                            <li className={`${styles.highlight}`} >
                                No caso de erro no upload, será gerada uma planilha com o descritivo do erro de leitura na última coluna. Favor consultar, ajustar e carregar novamente.
                            </li>
                        </ul>

                    </div>
                    <div className={`${styles.importacoes}`}>
                        <div className={`${styles.cardTitle}`}>
                            Upload de arquivo
                        </div>
                                        <FormControl>
                                            <input type='file' onChange={onFileChange} style={{display: 'none'}} ref={ref}/>
                                            <Button className={`customButton bigButton bold ${dados !== null ? styles.blue : null}`} onClick={callFileInput}>
                                                Adicionar planilha preenchida
                                            </Button>
                                        </FormControl>
                                        <FormControl>
                                            <Button className={`styles_processar__1ofBc bold`} onClick={parceiroImportacaoExcel}>
                                            {
                                                !loading ? 
                                                (
                                                    <>
                                                        <FontAwesomeIcon icon={faPlay} className={styles.icon}/>
                                                        PROCESSAR PLANILHA
                                                    </>
                                                ) :
                                                (
                                                    <FontAwesomeIcon icon={faSpinner} className={styles.icon} spin={true}/>
                                                )
                                            }
                                            </Button>
                                        </FormControl>
                                        <FormControl>
                                            <Button className={`customButton bigButton bold ${dados !== null ? styles.blue : null}`} onClick={() => history.goBack()}>
                                                Retornar ao cadastro de treinamento
                                            </Button>
                                        </FormControl>
                    </div>
                </div>
            </div>

            <div className={`${styles.actions}`}>
                <div className={`${styles.logs}`}>
                    <div className={`${styles.cardTitle}`}>
                        Log de importação
                    </div>
                    <div>
                        {
                            logList.map(log => (<LogImportacao log={log} key={log.id} />))
                        }
                    </div>
                    <div className={styles.paginacaoWrapper}>
                        <Paginacao maxPage={logMaxPage} page={logPage} setPage={setLogPage}/>
                    </div>
                </div>
            </div>
                       
        </div>
    )
}

